import './GameViews/gamePhase2.css';
import React, { useState, useEffect } from "react";
import EventCategoryList from "./datasets/event_category_list";
     
  const GameSpinner = (props) => {
      const [arrowRotation, setArrowRotation] = useState(0);
      const [spinArrowFullCircle, setArrowFullCircle] = useState(false);

    useEffect(() => {
        if (props.startSpinner === true) {
            setArrowRotation(0);
            setArrowFullCircle(props.startSpinner);
        }
        }, [props.startSpinner]);

            
    const setFullCircle = () => {
        setArrowFullCircle(true);
        setArrowRotation(0);
    }

    const spinArrow = () => {
        setArrowFullCircle(false);
        const eventCategoryObj = EventCategoryList.find(elem => elem.category === props.eventCategory);
        const spinNbr = eventCategoryObj.number;
        let arrowRotation = (spinNbr - 1) * 45 + 22.5;
        setArrowRotation(arrowRotation);
        setTimeout(() => {
            props.onSpin();
            }, 200);
    }
    
    return (
       
        <div className="wheelContainer">
                <div className="one">1</div>
                <div className="two">2</div>
                <div className="three">3</div> 
                <div className="four">4</div>
                <div className="five">5</div>
                <div className="six">6</div>
                <div className="seven">7</div>
                <div className="eight">8</div>
               
                <button id="spin" 
                    onClick={ 
                        () => setFullCircle()} disabled={props.spinnerDisabled}
                    >Spin
                </button>
                {props.displayPointer ?
                    <div className="spinner-pointer-position">
                        <img src="./assets/Icons/clickImg.jpg" 
                              className="click-image-icon-size"
                              alt="clickImageIcon" />
                    </div>
                :
                    null
                }
                {spinArrowFullCircle ?
                     <img src={'./assets/arrow.png'} 
                        className="spinnerArrow spinArrowAround"  alt={'arrow'}
                        onAnimationEnd={() => spinArrow()}
                        style={{transform: `rotate(${arrowRotation}deg)`,
                         }}
                     />
                :
                    <img src={'./assets/arrow.png'} 
                        className="spinnerArrow"  alt={'arrow'}
                        style={{transform: `rotate(${arrowRotation}deg)`,
                            }}
                    />
                }
           
        </div>
      )
    
   
}   

export default GameSpinner;    